import React, { type ReactNode } from 'react';

import { useResponsive } from '@garnish/core';
import { TransparentModal } from '@garnish/overlays';

/**
 * Component that renders either a drawer or a modal depending on viewport.
 */
export const BagDynamicModal = (props: BagDynamicModalProps) => {
  const { accessibilityLabel, children, onClose } = props;

  const { match } = useResponsive();

  return (
    <TransparentModal
      accessibilityLabel={accessibilityLabel}
      size={match(['full', 'drawer'])}
      mobileEdges={['right', 'left']}
      onClose={onClose}
    >
      {children}
    </TransparentModal>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type BagDynamicModalProps = {
  accessibilityLabel: string;
  children: ReactNode;
  onClose: () => void;
};
